// TODO: This duplicates destinationSelectorStore.ts from TripOverview and should be refactored https://trello.com/c/4wELjdBw

import { defineStore } from 'pinia';
import { ref } from 'vue';

import { HotelIngredient } from '@apps/main/modules/recipe/ingredients';
import { useRecipeStore } from '@apps/main/new-desktop/core/stores/recipe/recipeStore';
import { getSearchTerm } from '@apps/main/new-desktop/core/helpers/searchTerm.helper';

import {
  isDestinationAutoCompleteSuggestion,
  isHotelAutoCompleteSuggestion,
} from '@libs/trip-planner-interfaces';
import type {
  HeartedHotel,
  AutoCompleteSuggestion,
  IngredientId,
} from '@libs/trip-planner-interfaces';

export const useHotelSelectionDestinationSelectorStore = defineStore(
  'HotelSelectionDestinationSelectorStore',
  () => {
    const recipeStore = useRecipeStore();

    // State
    const searchText = ref<string>('');
    const editingIngredientId = ref<IngredientId | undefined>(undefined);

    // Actions
    function setDestinationSelectorData(
      newSearchText: string,
      ingredientId: IngredientId | undefined
    ): void {
      searchText.value = newSearchText;
      editingIngredientId.value = ingredientId;
    }

    function handleConfirmSelection(
      newDestination: AutoCompleteSuggestion
    ): void {
      if (editingIngredientId.value) {
        updateDestination(newDestination, editingIngredientId.value);
      } else {
        addNewDestination(newDestination);
      }
      clearDestinationSelectorData();
    }

    function clearDestinationSelectorData(): void {
      searchText.value = '';
      editingIngredientId.value = undefined;
    }

    function updateDestination(
      newDestination: AutoCompleteSuggestion,
      ingredientId: IngredientId
    ): void {
      let polygonId: number | undefined = undefined;

      if (isDestinationAutoCompleteSuggestion(newDestination)) {
        polygonId = newDestination.polygonId;
      }

      if (isHotelAutoCompleteSuggestion(newDestination)) {
        polygonId = newDestination.hotel.mainPolygonId;
      }

      const searchTerm = getSearchTerm({
        polygonId,
        freeText: newDestination.label,
      });

      recipeStore.updateHotelIngredientById(ingredientId, searchTerm);
      if (isHotelAutoCompleteSuggestion(newDestination)) {
        const heartedHotel: HeartedHotel = {
          code: newDestination.hotel.hotelCode,
        };
        recipeStore.updateHotelHeartedHotel(ingredientId, heartedHotel);
      }
    }

    function addNewDestination(newDestination: AutoCompleteSuggestion): void {
      const polygonId = isDestinationAutoCompleteSuggestion(newDestination)
        ? newDestination.polygonId
        : undefined;

      const searchTerm = getSearchTerm({
        polygonId,
        freeText: newDestination.label,
      });

      const newHotelIngredient = new HotelIngredient(searchTerm, true);
      recipeStore.addIngredient(newHotelIngredient);
    }

    return {
      // State
      searchText,

      // Actions
      clearDestinationSelectorData,
      handleConfirmSelection,
      setDestinationSelectorData,
    };
  }
);
